import { appendToUrl } from "../search/urlUtils";
import { disableAndNextStep, toggleDifferentTypeAddress } from "../checkout/stepsCT";
import { reInitVisualSteps } from "./visualSteps";
import { getDeliverySchedule } from "../checkout/components/deliveryScheduleUtil";
import { GTM_HOME, GTM_CG, GTM_NEW_ADDRESS, GTM_CHANGE_ADDRESS} from "../utilities/constants";
import { shippingEventsRadioButtonChangeEvent, loadStores } from "./shippingCT";
import { updateCartSummaryModalClass } from "../components/cartUtil";
import store from "@continente/vue/components/store";
import { isLastShippingSchedule } from "./checkoutUtil";

const $cache = {
    $shippingCoverageModal: $("#shipping-coverage-area-modal"),
    $shippingNewAddresModal: $("#shipping-new-address-modal")
};

let previousCheckedStoreAddress = $(".step-body--selection-column").find(".pwc-form-check-input:checked").first();

/**
 * Update Shipping method using data-address-store custom attribute
 * @param {Object} step - step to update
 * @param {String} addressOrStore - is address or store type selected for the step
 */
const updateShippingMethod = (step, addressOrStore) => {
    if (!step) {
        return;
    }

    step.setAttribute("data-address-store", addressOrStore);
};

/**
 * Update Shipping Resume section
 * @param {Object} radioTarget - clicked radio
 */
const updateShippingResume = radioTarget => {
    const shippingName = radioTarget.querySelector(".js-label-method-name").innerText;
    const shippingAddress = radioTarget.querySelector(".js-label-address").innerText;

    radioTarget.closest(".js-step-body-inner").querySelector(".js-shipping-resume-address-name").innerHTML = shippingName;
    radioTarget.closest(".js-step-body-inner").querySelector(".js-shipping-resume-address-details").innerHTML = shippingAddress;
};

/**
 * Update Coverage Area
 */
const updateCoverageArea = targetParams => {
    const $shippingConfirmCoverageModal = $("#shipping-confirm-coverage-area-modal");
    const storeGetCoverageURL = $(".js-store-getcoverage-url").attr("data-url");
    const storeSetContextURL = $(".js-store-setcontext-url").attr("data-url");

    let params = {
        postalCode: targetParams.selectedPostal
    };

    $.ajax({
        url: storeGetCoverageURL,
        type: "GET",
        data: params,
        success: response => {
            if (!response.error) {
                // call SetStoreContext (needs storeId and storeInfo)
                params = {
                    storeId: response.data.storeId,
                    physicalStoreId: response.data.physicalStoreId,
                    areaID: response.data.areaID,
                    storeID: response.data.storeID,
                    storeInfo: targetParams.selectedDeliveryLocation || "",
                    storePostalCode: targetParams.selectedPostal,
                    latitude: targetParams.selectedDeliveryLatitude || "",
                    longitude: targetParams.selectedDeliveryLongitude || "",
                    searchLatitude: targetParams.selectedDeliveryLatitude || "",
                    searchLongitude: targetParams.selectedDeliveryLongitude || "",
                    ID: targetParams.selectedStoreId,
                    selectedAddressId: targetParams.selectedAddressId
                };

                $.post(storeSetContextURL, params, responseData => {
                    if (!responseData.error) {

                        window.onbeforeunload = null;

                        //GTM logic start
                        document.dispatchEvent(new CustomEvent("dataLayer.deliveryAreaEvents", {
                            detail: {
                                "status": response.data.customerStatus,
                                "action": targetParams.newAddress ? GTM_NEW_ADDRESS : GTM_CHANGE_ADDRESS,
                                "type": targetParams.selectedStoreId ? GTM_CG : GTM_HOME
                            }
                        }));
                        //GTM logic end

                        $.spinner().stop();
                        $shippingConfirmCoverageModal.attr("data-page-reload", "true").modal("hide");
                        location.reload();

                        // Redirect to Cart page
                        let cartURL = $(".js-cart-url").attr("data-url");
                        cartURL = appendToUrl(cartURL, {"isCheckoutRedirected" : true});
                        window.location.href = cartURL;
                    } else {
                        $.spinner().stop();
                        $shippingConfirmCoverageModal.modal("hide");
                        showCoverageAreaErrorModal();
                    }
                });
            } else {
                $.spinner().stop();
                $shippingConfirmCoverageModal.modal("hide");
                showCoverageAreaErrorModal();
            }
        }
    });
};

/**
 * Update Shipment Address
 * @param {Object} params - address params
 * @param {Object} activeStep - function will work with this step
 * @param {Boolean} fromNewStoreModal - show if selected from new store modal
 */
const updateShipmentAddress = (params, activeStep, fromNewStoreModal) => {
    const activeStepId = activeStep.attr("id");
    const activeStepSelector = document.querySelector(`#${activeStepId}`);
    const updateShipmentAddressUrl = activeStep.attr("data-update-shipment-address-url");
    let checkedAddress = $(activeStepSelector).find(".pwc-form-check-input:checked").first();
    const isNewAddressSelected = isNewAddressInputSelected(checkedAddress);
    const addressId = checkedAddress.val();
    const isHome = fromNewStoreModal ? !fromNewStoreModal : checkedAddress.closest(".pwc-form-radio").hasClass("shipping-address--wrapper");
    const shipmentUUID = activeStep.closest(".shipping-step--wrapper").data("shipment-uuid");
    const paramsStoreID = params.selectedStoreId;
    let requestObj = {};

    if (params && params.addNewAddress) {
        requestObj.addressId = params.addressId;
        requestObj.isHome = params.isHome;
        requestObj.shipmentUUID = shipmentUUID;
        requestObj.newAddressCheckout = isNewAddressSelected;
    } else {
        requestObj.addressId = addressId;
        requestObj.isHome = fromNewStoreModal ? !fromNewStoreModal : isHome;
        requestObj.shipmentUUID = shipmentUUID;
        requestObj.paramsStoreID = paramsStoreID;
    }

    if (updateShipmentAddressUrl) {
        $.ajax({
            url: updateShipmentAddressUrl,
            type: "POST",
            data: requestObj,
            success: data => {
                if (data.success) {
                    const address = data.address;
                    const resources = data.resources;
                    const isHomeDelivery = data.isHome;
                    if (!address) {
                        return;
                    }

                    const addressName = address.addressName;
                    const addressString = getAddressString(address, resources);

                    //if new address created is from the same coverage area
                    if (params && params.addNewAddress) {
                        [...document.querySelectorAll(".shipping-step--wrapper")].forEach(item => {
                            const shippingStepWrapper = $(item);
                            const shipmentIndex = shippingStepWrapper.find(".step-type--address").data("shipment-index");
                            const addressSection = shippingStepWrapper.find(".step-body--selection-left");
                            const sibling = addressSection.find(".pwc-form-check-input")[0];

                            address.shipmentIndex = shipmentIndex;
                            const newAddressTemplate = getNewAddressTemplate(address, sibling, resources);
                            const addNewAddressButton = addressSection.find(".js-action-new-address");
                            const $newAddressInput = shippingStepWrapper.find(".js-new-address-input:checked");
                            if ($newAddressInput.length) {
                                $newAddressInput.parent(".js-type-address").remove();
                            }
                            $(newAddressTemplate).insertBefore(addNewAddressButton);
                            const radioButton = addressSection.find(`#shipment-${shipmentIndex}-${address.mdmAddressId}`);

                            if (radioButton.length) {
                                shippingEventsRadioButtonChangeEvent(radioButton[0]);
                            }
                        });

                        checkedAddress.prop("checked", false);
                        checkedAddress = $(activeStepSelector).find(`input[id*="${address.mdmAddressId}"]`);
                        checkedAddress.prop("checked", true);

                        const shippingNewAddressModal = $("#shipping-new-address-modal");
                        const addressForm = shippingNewAddressModal.find(".address-form");
                        addressForm.trigger("reset");
                        addressForm.find(".pwc-form-input").removeClass("filled");

                        // Hide current modal
                        if (window.mqRespond.status.mobile) {
                            const shippingCoverageModal = $("#shipping-coverage-area-modal");
                            if (shippingCoverageModal.length) {
                                shippingCoverageModal.modal("hide");
                            }
                        } else {
                            shippingNewAddressModal.modal("hide");
                        }
                    }

                    const $shippingNewStoreModal = $("#shipping-new-store-modal");

                    activeStep.attr("data-address-store", isHomeDelivery ? "address" : "store");

                    activeStep.find(".js-shipping-resume-address-name").html(addressName).removeClass("d-none");
                    activeStep.find(".js-shipping-resume-address-details").text(addressString).removeClass("d-none");

                    const stepActiveID = activeStepSelector.querySelector(".js-step-header-active")?.id;

                    // Code to verify if the new shipment address is a transition from Home to Click&Go and vice-versa.
                    if (isHome && stepActiveID != "receive-address" || !isHome && stepActiveID != "receive-store") {
                        toggleDifferentTypeAddress(activeStepSelector);
                        $("#shipping-new-store-modal").modal("hide");
                        $("#shipping-address-modal").modal("hide");
                    } else {
                        activeStepSelector.querySelector(".js-step-body-resume")?.classList.add("d-none");
                    }

                    disableAndNextStep(activeStepSelector);
                    reInitVisualSteps();

                    if (isHomeDelivery) {
                        $shippingNewStoreModal.find(".pwc-form-check-input").prop("checked", false);
                        loadStores(checkedAddress);
                    } else {
                        $shippingNewStoreModal.find(`#store-${paramsStoreID}`).find(".pwc-form-check-input").prop("checked", true);
                    }

                    if (fromNewStoreModal) {
                        activeStep.find(".pwc-form-check-input").prop("checked", false);
                        $(`#${paramsStoreID}`).prop("checked", true);
                    }

                    // Set previous address based on attribute' last value
                    // Update the attribute with the current selected delivery
                    previousCheckedStoreAddress = activeStep.attr("data-selected-delivery");
                    activeStep.attr("data-selected-delivery", isHomeDelivery ? address.mdmAddressId : paramsStoreID);

                    if (data.resetSlotPriceData && data.resetSlotPriceData.orderShippingTotal) {
                        const resetSlotPriceData = data.resetSlotPriceData;
                        let checkoutOrderSummaryInfo = store.getters.getOrderSummaryInfo();
                        let checkoutShipmentInformation = store.getters.getShipmentInformation();

                        checkoutOrderSummaryInfo.shipping.forEach(element => {
                            if (element.externalShipmentID == resetSlotPriceData.shipmentID) {
                                element.selectedShippingMethod.shippingCost = resetSlotPriceData.shipmentTotalPrice;
                                element.selectedShippingMethod.shipmentOriginalPrice = resetSlotPriceData.shipmentOriginalPrice;
                                checkoutShipmentInformation.forEach(shipment => {
                                    if (shipment.shipmentID == resetSlotPriceData.shipmentID) {
                                        shipment.originalPrice = resetSlotPriceData.shipmentOriginalPrice;
                                        shipment.discountPrice = resetSlotPriceData.shipmentTotalPrice;
                                    }
                                });
                            }
                        });

                        checkoutOrderSummaryInfo.totals.grandTotal = resetSlotPriceData.totalGrossPrice;
                        checkoutOrderSummaryInfo.totals.couponLevelDiscountTotal = resetSlotPriceData.couponLevelDiscountTotal;

                        store.commit("setOrderSummaryInfo", checkoutOrderSummaryInfo);
                        store.commit("setShipmentInformation", checkoutShipmentInformation);
                    }

                    //GTM logic start
                    document.dispatchEvent(new CustomEvent("dataLayer.deliveryAreaEvents", {
                        detail: {
                            "status": params.customerStatus,
                            "action": "change address",
                            "type": isHomeDelivery ? GTM_HOME : GTM_CG
                        }
                    }));
                    //GTM logic end

                    /*
                        when selecting new delivery method the previous slots will be removed,
                        container will be recreated as the and data attribute will be reset,
                        container and data attribute will be filled with new data received from ajax call
                        and vue will be reinitialized in initDeliverySchedule()
                    */
                    const shippingContainer = activeStepSelector.closest(".shipping-step--wrapper");
                    const slotContainer = shippingContainer.querySelector(".shipping-delivery-slot");
                    slotContainer.dataset.shipmentDeliverySlots = "";

                    getDeliverySchedule(slotContainer);

                    $("#shipping-confirm-coverage-area-modal").modal("hide");
                } else {
                    disableAndNextStep(document.querySelector(`#${activeStepId}`));

                    if (previousCheckedStoreAddress && previousCheckedStoreAddress.length) {
                        previousCheckedStoreAddress.prop("checked", true);
                    } else {
                        activeStep.find(".pwc-form-check-input").prop("checked", false);
                    }
                }
            }
        });
    } else {
        previousCheckedStoreAddress.prop("checked", true);
    }
};

/**
 * Returns the address as string
 * @param {Object} address - address object
 */
const getAddressString = (address, resources) => {
    const addressArray = [];

    if (address.address1) {
        addressArray.push(address.address1);
    }
    if (address.address2) {
        addressArray.push(address.address2);
    }
    if (address.door) {
        addressArray.push(`${resources.door} ${address.door}`);
    }
    if (address.floor) {
        addressArray.push(`${address.floor} ${resources.floor}`);
    }
    if (address.side) {
        addressArray.push(`${resources.side} ${address.side}`);
    }
    if (address.stateCode) {
        addressArray.push(address.stateCode);
    }
    if (address.postalCode) {
        addressArray.push(address.postalCode);
    }
    if (address.city) {
        addressArray.push(address.city);
    }

    return addressArray.join(", ");
};

/**
 * Checks if coverage area will be changed with selected delivery address
 * @param {Object} targetParams - address object
 * @param {Function} callback = callback function that will return value from ajax call
 */
const checkCoverageArea = (targetParams, callback) => {
    const storeGetCoverageURL = $(".js-store-getcoverage-url").attr("data-url");

    let params = {
        postalCode: targetParams.selectedPostal
    };

    $.ajax({
        url: storeGetCoverageURL,
        type: "GET",
        data: params,
        async: false,
        success: response => {
            callback(response);
        }
    });
};

const getPreviousCheckedAddressStore = callback => {
    callback(previousCheckedStoreAddress.first());
};

/**
 * Shows coverage area error modal
 * @param {Boolean} fromNewStoreModal - check if function called from new address modal
 * @param {Object} lastCheckedStoreOnMap - selector for the last selected store on map
 */
const showCoverageAreaErrorModal = (fromNewStoreModal, lastCheckedStoreOnMap) => {
    const $checkoutCoverageAreaErrorModal = $("#checkout-coverage-area-error");
    const $shippingNewStoreModal = $("#shipping-new-store-modal");

    if (fromNewStoreModal) {
        $shippingNewStoreModal.modal("hide");
    }

    $checkoutCoverageAreaErrorModal.modal("show");
    updateCartSummaryModalClass(true);

    if (previousCheckedStoreAddress && previousCheckedStoreAddress.length) {
        previousCheckedStoreAddress.prop("checked", true);
    } else {
        $(".step-body--selection-column").find(".pwc-form-check-input").prop("checked", false);
    }

    $("body").off("hidden.bs.modal").on("hidden.bs.modal", "#checkout-coverage-area-error", () => {
        if (!fromNewStoreModal) {
            return;
        }

        if ((!previousCheckedStoreAddress || !previousCheckedStoreAddress.length) && lastCheckedStoreOnMap && lastCheckedStoreOnMap.length) {
            lastCheckedStoreOnMap.prop("checked", true);
        } else {
            const $deliveryNearest = $shippingNewStoreModal.find(".delivery-nearest");
            let previousCheckedStoreAddressId = previousCheckedStoreAddress.attr("id");

            if (previousCheckedStoreAddressId) {
                let selectedStoreMapRadio = $deliveryNearest.find(`#store-${previousCheckedStoreAddressId}`);
                if (selectedStoreMapRadio && selectedStoreMapRadio.length) {
                    selectedStoreMapRadio.find(".pwc-form-check-input").prop("checked", true);
                } else {
                    $deliveryNearest.find(".pwc-form-check-input").prop("checked", false);
                }

            }
        }

        $shippingNewStoreModal.modal("show");
        updateCartSummaryModalClass(true);
    });
};

/**
 * Creates new address on client side if coverage area is not changed
 * @param {Object} addressData - addressDataReceived from response
 * @param {Object} sibling - DOM element, the future sibling
 */
const getNewAddressTemplate = (addressData, sibling, resources) => {
    let addressString = getAddressString(addressData, resources);
    const addressID = addressData.mdmAddressId;
    const zipCode = addressData.postalCode;
    const addressTitle = addressData.addressName;
    const shipmentIndex = addressData.shipmentIndex;
    const getCoverageUrl = $(".js-store-getcoverage-url").data("url");
    const setContextUrl = $(".js-store-setcontext-url").data("url");
    const inputName = sibling.name;

    if (addressString && addressString.length > 0) {
        let findReplace = [[/&/g, "&amp;"], [/</g, "&lt;"], [/>/g, "&gt;"], [/"/g, "&quot;"]];
        for (let item in findReplace) {
            addressString = addressString.replace(findReplace[item][0], findReplace[item][1]);
        }
    }

    return `<div class="pwc-form-radio shipping-address--wrapper js-type-address"
                data-postal="${zipCode}"
                data-address-id="${addressID}"
                data-store-id=""
                data-delivery-location="${zipCode}"
                data-store-getcoverage="${getCoverageUrl}"
                data-store-setcontext="${setContextUrl}">

                <input type="radio" title id="shipment-${shipmentIndex}-${addressID}" name="${inputName}" value="${addressID}" class="pwc-form-check-input"/>

                <label class="pwc-form-check-label address-label" for="${addressID}">
                    <p class="pwc-mb--0 js-label-method-name">${addressTitle}</p>
                    <p class="pwc-mb--0 js-label-address">${addressString}</p>
                </label>
                <span class="checkmark"></span>
            </div>`;
};

/**
 * Check if the radio input provided is the one for a new address
 * @param {Object} $radioInput - jQuery object
 * @returns Boolean
 */
const isNewAddressInputSelected = $radioInput => {
    if (!$radioInput) { return false; }
    return $radioInput.hasClass("js-new-address-input");
};

/**
 * Handles new address modal display on different breakpoints and prefilling
 * @param {Object} $radioInput - jQuery object
 */
const openNewAddressModal = $radioInput => {
    if (!$radioInput) { return; }
    const isPostalCode = $radioInput.attr("data-is-postal-code") == "true" ? true : false;
    const valueToPrefill = $radioInput.attr("data-delivery-location");

    $cache.$shippingNewAddresModal.modal("show");
    $cache.$shippingNewAddresModal.one("shown.bs.modal", event => {
        if (!valueToPrefill) { return; }
        const $currentModal = $(event.currentTarget);
        const elementIdToPrefill = isPostalCode ? "#zipCode" : "#city";
        $currentModal.find(`${elementIdToPrefill}`).val(valueToPrefill).addClass("filled");
    });
};

/**
 * Handles the toggle to allow the customer to proceed to the next slide only if a shipping slot is selected
 */
const enableNextSlideValidation = () => {
    const $shipmentsContainer = $(".js-shipment-steps-container");
    const currentSlideIndex = $shipmentsContainer.slick("slickCurrentSlide");
    const shipmentInformation = store.getters.getShipmentInformation();
    const shipmentDeliverySlots = document.querySelectorAll(".shipping-delivery-slot");
    const isLastSlide = isLastShippingSchedule($shipmentsContainer);
    const currentSlideShipmentContainer = shipmentDeliverySlots[currentSlideIndex].querySelectorAll(".interval-item-wrapper.selected");
    const currentShippingStepID = shipmentDeliverySlots[currentSlideIndex]?.getAttribute("data-shipment-id");
    const shipmentFromStoreGetters = shipmentInformation.find(shipment => shipment.shipmentID === currentShippingStepID);
    const isSlotSelected = shipmentFromStoreGetters && shipmentFromStoreGetters?.chosenPrice != "-" ? true : false;
    const isEntregaZero = $shipmentsContainer[0]?.querySelector(".js-delivery-slot-entrega-zero");
    let canProceed = (isSlotSelected || isEntregaZero || currentSlideShipmentContainer.length) && !isLastSlide;
    let arrow = document.querySelector(".js-checkout-shippment-arrows .shipment-next-arrow");

    arrow.classList.toggle("slick-disabled", !canProceed);
};

export {
    updateShippingMethod,
    updateShippingResume,
    updateCoverageArea,
    updateShipmentAddress,
    checkCoverageArea,
    getPreviousCheckedAddressStore,
    showCoverageAreaErrorModal,
    isNewAddressInputSelected,
    openNewAddressModal,
    enableNextSlideValidation
};
